// Global array to track all active Swiper instances
let activeSwiperInstances = [];

// Cache for hero content DOM elements
let heroContentCache = null;

/**
 * Add Swiper instance to tracking array
 * @param {Swiper} swiper - The swiper instance to track
 * @returns {void}
 */
export const trackSwiperInstance = swiper => {
  if (swiper && activeSwiperInstances.indexOf(swiper) === -1) {
    activeSwiperInstances.push(swiper);
  }
};

/**
 * Destroy all active Swiper instances
 * @returns {void}
 */
export const destroyAllSwipers = () => {
  try {
    activeSwiperInstances.forEach(swiper => {
      if (swiper && typeof swiper.destroy === 'function') {
        // Stop autoplay if it exists
        if (swiper.autoplay && typeof swiper.autoplay.stop === 'function') {
          swiper.autoplay.stop();
        }

        // Destroy the swiper instance completely
        swiper.destroy(true, true); // removeClasses = true, removeStyles = true
      }
    });
    activeSwiperInstances = [];

    // Additional cleanup: remove any remaining swiper-related styles or classes
    document.querySelectorAll('.swiper-slide-active, .swiper-slide-next, .swiper-slide-prev').forEach(slide => {
      slide.classList.remove('swiper-slide-active', 'swiper-slide-next', 'swiper-slide-prev');
    });


  } catch (error) {
    console.error('Error destroying Swiper instances:', error);
    // Reset the array even if there were errors
    activeSwiperInstances = [];
  }
};

/**
 * Clear hero content cache (call when page changes)
 * @returns {void}
 */
export const clearHeroContentCache = () => {
  heroContentCache = null;
};

/**
 * Get cached hero content DOM elements
 * @returns {Object|null} Cached DOM elements
 */
export const getHeroContentCache = () => {
  if (!heroContentCache) {
    const container = document.querySelector('.widget-hero__content');
    if (!container) return null;

    heroContentCache = {
      container,
      counter: container.querySelector('.widget-hero__counter'),
      title: container.querySelector('.widget-hero__title'),
      subtitle: container.querySelector('.widget-hero__subtitle'),
      description: container.querySelector('.widget-hero__description'),
      ctas: container.querySelectorAll('.widget-hero__ctas .btn'),
      badgesContainer: container.querySelector('.widget-hero__badges'),
      metaContainer: container.querySelector('.widget-hero__meta'),
    };
  } else {
    // Validate cache - if elements are no longer in DOM, clear cache
    if (!document.contains(heroContentCache.container)) {
      heroContentCache = null;
      return getHeroContentCache(); // Recursive call to rebuild cache
    }
  }
  return heroContentCache;
};


/**
 * Get cached hero content DOM elements
 * @returns {Object|null} Cached DOM elements
 */
export const getHeroContentCacheV2 = () => {
  if (!heroContentCache) {
    const container = document.querySelector('.widget-hero-v2__content');
    if (!container) return null;

    heroContentCache = {
      container,
      counter: container.querySelector('.widget-hero-v2__counter'),
      title: container.querySelector('.widget-hero-v2__title'),
      subtitle: container.querySelector('.widget-hero-v2__subtitle'),
      description: container.querySelector('.widget-hero-v2__description'),
      ctas: container.querySelectorAll('.widget-hero-v2__ctas .btn'),
      badgesContainer: container.querySelector('.widget-hero-v2__badges'),
      metaContainer: container.querySelector('.widget-hero-v2__meta'),
    };
  } else {
    // Validate cache - if elements are no longer in DOM, clear cache
    if (!document.contains(heroContentCache.container)) {
      heroContentCache = null;
      return getHeroContentCacheV2(); // Recursive call to rebuild cache
    }
  }
  return heroContentCache;
};
